export default "__VITE_ASSET__D91HKO_3__"